import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function ProtectedRoute({ children }) {
  const navigate = useNavigate();
  const [state, setState] = useState("checking"); // checking | ok | denied

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return;
    const check = async () => {
      try {
        const { data } = await api.get("/auth/me");
        if (data.is_admin) {
          setState("ok");
        } else {
          setState("denied");
        }
      } catch (e) {
        navigate("/admin/login");
      }
    };
    check();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (state === "checking") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0F1C]" data-testid="admin-loading">
        <div className="h-10 w-10 rounded-full border-2 border-white/20 border-t-blue-500 animate-spin" />
      </div>
    );
  }

  if (state === "denied") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0F1C] px-6" data-testid="admin-denied">
        <div className="text-center max-w-md">
          <h1 className="font-display text-2xl font-bold text-white">Access restricted</h1>
          <p className="mt-3 text-slate-400 text-sm">
            Your account is not authorised for the DecisionOS admin dashboard. Please contact the
            administrator to be added to the access list.
          </p>
          <button
            data-testid="denied-back-btn"
            onClick={() => navigate("/")}
            className="mt-6 px-5 py-2.5 rounded-full bg-blue-600 hover:bg-blue-500 text-white text-sm font-medium transition-colors"
          >
            Back to home
          </button>
        </div>
      </div>
    );
  }

  return children;
}
